// ============================================
// NAVBAR SCROLL MODULE
// ============================================
// Przełącza navbar--negative na positive (navbar--scrolled)
// po przeskrolowaniu 30% wysokości okna przeglądarki

(function () {
    'use strict';

    const navbar = document.querySelector('.navbar--negative');
    if (!navbar) return;

    let threshold = window.innerHeight * 0.3;

    function onScroll() {
        if (window.scrollY >= threshold) {
            navbar.classList.add('navbar--scrolled');
        } else {
            navbar.classList.remove('navbar--scrolled');
        }
    }

    function onResize() {
        threshold = window.innerHeight * 0.3;
        onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    // Initial check
    onScroll();
})();
